const PRICE_TYPE_OUT_VOICE = 'out_voice';
const PRICE_TYPE_INC_VOICE = 'inc_voice';
const PRICE_TYPE_PBX_OUT_VOICE = 'pbx_out_voice';
const PRICE_TYPE_PBX_INC_VOICE = 'pbx_inc_voice';
const PRICE_TYPE_AUTOCALLER_OUT_VOICE = 'autocaller_out_voice';
const PRICE_TYPE_AUTOCALLER_INC_VOICE = 'autocaller_inc_voice';
const PRICE_TYPE_PREDICTIVE_OUT_VOICE = 'predictive_out_voice';
const PRICE_TYPE_PREDICTIVE_INC_VOICE = 'predictive_inc_voice';
const PRICE_TYPE_AMO_OUT_VOICE = 'amo_out_voice';
const PRICE_TYPE_AMO_INC_VOICE = 'amo_inc_voice';
const PRICE_TYPE_KOMMO_OUT_VOICE = 'kommo_out_voice';
const PRICE_TYPE_KOMMO_INC_VOICE = 'kommo_inc_voice';
const PRICE_TYPE_SMS = 'sms';
const PRICE_TYPE_HLR = 'hlr';
const PRICE_TYPE_SMS_NUMBER_VERIFICATION = 'sms_number_verification';
const PRICE_TYPE_VERIFICATION_BY_OUT_VOICE = 'phone_number_verification';
const PRICE_TYPE_VERIFICATION_BY_INC_VOICE = 'call_number_verification';
const PRICE_TYPE_VERIFICATION_BY_INC_VOICE_CODE = 'voice_number_verification';

const SERVICES = [
  PRICE_TYPE_OUT_VOICE,
  PRICE_TYPE_INC_VOICE,
  PRICE_TYPE_PBX_OUT_VOICE,
  PRICE_TYPE_PBX_INC_VOICE,
  PRICE_TYPE_AUTOCALLER_OUT_VOICE,
  PRICE_TYPE_AUTOCALLER_INC_VOICE,
  PRICE_TYPE_PREDICTIVE_OUT_VOICE,
  PRICE_TYPE_PREDICTIVE_INC_VOICE,
  PRICE_TYPE_AMO_OUT_VOICE,
  PRICE_TYPE_AMO_INC_VOICE,
  PRICE_TYPE_KOMMO_OUT_VOICE,
  PRICE_TYPE_KOMMO_INC_VOICE,
  PRICE_TYPE_SMS,
  PRICE_TYPE_HLR,
  PRICE_TYPE_SMS_NUMBER_VERIFICATION,
  PRICE_TYPE_VERIFICATION_BY_OUT_VOICE,
  PRICE_TYPE_VERIFICATION_BY_INC_VOICE,
  PRICE_TYPE_VERIFICATION_BY_INC_VOICE_CODE
];

const RULES = [
  PRICE_TYPE_OUT_VOICE,
  PRICE_TYPE_INC_VOICE,
  PRICE_TYPE_PBX_OUT_VOICE,
  PRICE_TYPE_PBX_INC_VOICE,
  PRICE_TYPE_AUTOCALLER_OUT_VOICE,
  PRICE_TYPE_AUTOCALLER_INC_VOICE,
  PRICE_TYPE_PREDICTIVE_OUT_VOICE,
  PRICE_TYPE_PREDICTIVE_INC_VOICE,
  PRICE_TYPE_AMO_OUT_VOICE,
  PRICE_TYPE_AMO_INC_VOICE,
  PRICE_TYPE_KOMMO_OUT_VOICE,
  PRICE_TYPE_KOMMO_INC_VOICE,
];

const isVoiceService = (serviceName: string) => {
  return (
    serviceName === PRICE_TYPE_OUT_VOICE ||
    serviceName === PRICE_TYPE_INC_VOICE ||
    serviceName === PRICE_TYPE_PBX_OUT_VOICE ||
    serviceName === PRICE_TYPE_PBX_INC_VOICE ||
    serviceName === PRICE_TYPE_AUTOCALLER_OUT_VOICE ||
    serviceName === PRICE_TYPE_AUTOCALLER_INC_VOICE ||
    serviceName === PRICE_TYPE_PREDICTIVE_OUT_VOICE ||
    serviceName === PRICE_TYPE_PREDICTIVE_INC_VOICE ||
    serviceName === PRICE_TYPE_AMO_OUT_VOICE ||
    serviceName === PRICE_TYPE_AMO_INC_VOICE ||
    serviceName === PRICE_TYPE_KOMMO_OUT_VOICE ||
    serviceName === PRICE_TYPE_KOMMO_INC_VOICE
  );
};

const isVoiceVerificationService = (serviceName: string) => {
  return (
    serviceName === PRICE_TYPE_VERIFICATION_BY_OUT_VOICE ||
    serviceName === PRICE_TYPE_VERIFICATION_BY_INC_VOICE ||
    serviceName === PRICE_TYPE_VERIFICATION_BY_INC_VOICE_CODE
  );
};

const isSmsVerificationService = (serviceName: string) => {
  return serviceName === PRICE_TYPE_SMS_NUMBER_VERIFICATION;
};

interface ISubPoints {
  name?: string;
  title: string;
  id: number;
}

interface IList {
  name: string;
  title: string;
  single?: boolean;
  subPoints: ISubPoints[];
}

const getFirstServiceName = (list: IList[]) => {
  return list[0]?.subPoints.length > 0 ? list[0]?.subPoints[0].name : list[0]?.name;
};

const sortServicesByRule = (list: IList[]) => {
  return list?.sort((a, b) => {
    return RULES.indexOf(a?.name) - RULES.indexOf(b?.name);
  });
};

const getServicesMenu = (object: Object) => {
  return Object.entries(object || {}).map((i) => ({
    name: i[0],
    ...i[1]
  }));
};

const getVoiceServicesMenu = (services: Object) => {
  return sortServicesByRule(getServicesMenu(services))
};

// не используется, пока на бэкенде не сделаем нормальную логику для транков
const getVerificationServicesMenu = (services: Object) => {
  return [{ name: PRICE_TYPE_SMS_NUMBER_VERIFICATION }, ...getServicesMenu(services)];
};

const getTemporaryVerificationServicesMenu = (services: Object) => {
  return [
    { name: PRICE_TYPE_SMS_NUMBER_VERIFICATION },
    ...Object.entries(services || {})
      .map((i) => ({
        name: i[0],
        rate_id: i[1][0]?.id
      }))
      .filter((i) => i.name !== PRICE_TYPE_SMS_NUMBER_VERIFICATION)
  ];
};

export {
  PRICE_TYPE_SMS,
  SERVICES,
  PRICE_TYPE_AMO_OUT_VOICE,
  PRICE_TYPE_AMO_INC_VOICE,
  getFirstServiceName,
  isVoiceService,
  isVoiceVerificationService,
  isSmsVerificationService,
  getVoiceServicesMenu,
  getVerificationServicesMenu,
  getTemporaryVerificationServicesMenu
};
